import React from "react";
import Switch from '@mui/material/Switch';
import {isEmpty} from "../util/is";
import { styled } from '@mui/material/styles';
import {Colors} from "../assets/colors/Colors";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  marginTop: 5,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? Colors.GREEN_SWITCH_ACTIVE : Colors.GREEN_SWITCH_ACTIVE,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: Colors.GREEN_SWITCH_ACTIVE,
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? Colors.RED_SWITCH_INACTIVE : Colors.RED_SWITCH_INACTIVE,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));


export function validStateChecked(state) {

    if(isEmpty(state)){
        return false;
    }

    return state === 1 || state === "1" || state === true || state === "true";

}

const CustomSwitch = ({state, name, handleChange, disabled = false}) => {

    return(<IOSSwitch disabled={disabled} checked={validStateChecked(state)} onChange={({target:{name, checked}}) => handleChange(name, checked)} name={`switch${name}`} />);

}

export default CustomSwitch;
